import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ButtonStyleComponent, buttonStylesOptions, TButtonStyles } from '../../common/buttons/button-style/button-style.component';
import { NgClass } from '@angular/common';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { DfUiModule } from '@df/ui/df-ui.module';
import { DfModuleImageModule } from '@df/module-image/df-module-image.module';
import { defaultImage } from '../../icms.config';

export namespace NCmsServiceMessages {
    export interface IComponentData extends NICmsContentComponent.IData {
        services?: IServiceMessage[];
        display_text_component: boolean;
        heading?: string;
        text_style_heading;
    }

    /**
     * Link interface
     */
    export interface IServiceMessage {
        image: string;
        title?: string;
        description?: string;
        link?: string;
        button_text?: string;
        button_style?: TButtonStyles;
    }
}

@ICmsComponent<CmsServiceMessagesComponent>({
    id: 'service-messages',
    name: 'Service Messages',
    tags: ['PDP', 'Links'],
    fields: [
        <NICmsContentField.IToggleField>{
            key: 'display_text_component',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Desplay Text Component',
            labels: { true: 'Yes', false: 'No' },
            default: true,
            required: true
        },
        <NICmsContentField.IField>{
            key: 'heading',
            type: NICmsContentField.EFieldType.text,
            title: 'Heading',
            canShow: (data: NCmsServiceMessages.IComponentData) => data.display_text_component
        },
        <NICmsContentField.IChoiceField>{
            key: 'text_style_heading',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text style heading',
            options: TextStyleOptions,
            canShow: (data: NCmsServiceMessages.IComponentData) => data.display_text_component
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'services',
            title: 'Services',
            itemNameField: 'title',
            required: true,
            defaultSize: 4,
            maxSize: 4,
            fields: [
                {
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'image',
                    default: defaultImage,
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title',
                    default: 'Service Message'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.textarea,
                    key: 'description',
                    title: 'Description'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'button_text',
                    title: 'Button Text'
                },
                {
                    key: 'button_style',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Style',
                    options: buttonStylesOptions,
                    default: 'button'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'link',
                    title: 'Link',
                    default: '/'
                }
            ]
        },
        NICmsContentComponent.backgroundField
    ]
})
@Component({
    imports: [NgClass, ICmsClientModule, HrefComponent, ButtonStyleComponent, DfUiModule, DfModuleImageModule],
    selector: 'cms-service-messages',
    templateUrl: './cms-service-messages.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsServiceMessagesComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsServiceMessages.IComponentData;
}
